export enum ConfirmModalType {
    WaitingRoom = 'WaitingRoom',
    Default = 'Default',
}
